import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { ReactComponent as ArrowDownIcon } from '@doveconviene/sf-ui/icons/arrow_down.svg'
import { ReactComponent as ArrowUpIcon } from '@doveconviene/sf-ui/icons/arrow_up.svg'
import Icon from '../../../ui/Icon'

const StyledModeToggleCTA = styled.div(({ theme: { spaces } }) => ({
  display: 'inline-flex',
  width: '50%',
  maxWidth: `${spaces.default * 15}px`,
  cursor: 'pointer',
}))

const StyledModeToggleCTAContent = styled.div(({ theme: { colors, fontSize } }) => ({
  color: colors.primary,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  flex: 1,
  fontSize: fontSize * 0.825,
  fontWeight: 'bold',
}))

const StyledArrow = styled.div(({ theme: { spaces } }) => ({
  display: 'inline-block',
  width: spaces.large,
  height: spaces.large,
  margin: `-${spaces.default / 8}px 0 0 0`,
}))

const ModeToggleCTA = ({
  label,
  direction,
  onClick = () => false,
}) => (
  <StyledModeToggleCTA onClick={onClick} data-test={`ExpandableDrawerCTA_${direction}`}>
    <StyledModeToggleCTAContent>
      {label && (
        <span>{label}</span>
      )}
      <StyledArrow>
        <Icon>
          {direction === 'up' ? <ArrowUpIcon /> : <ArrowDownIcon />}
        </Icon>
      </StyledArrow>
    </StyledModeToggleCTAContent>
  </StyledModeToggleCTA>
)

ModeToggleCTA.propTypes = {
  label: PropTypes.string,
  direction: PropTypes.oneOf(['up', 'down']).isRequired,
  onClick: PropTypes.func.isRequired,
}

ModeToggleCTA.defaultProps = {
  label: '',
}

ModeToggleCTA.displayName = 'ModeToggleCTA'
ModeToggleCTA.whyDidYouRender = true

export default ModeToggleCTA
